module.exports = `${require.publicPath}login-bg.e0214131.png`;